function initialSort(data) {
    return data;
}
function symptomsInitialSort(data, order) {
    data.sort(symptomsInitSort(order));
    return data;
}
function adherenceInitialSort(data, order) {
    data.sort(medAdherenceInitSort(order));
    return data;
}
function lastAppUserInitialSort(data, order) {
    data.sort(lastAppUsedInitialSort(order));
    return data;
}
function protocolSortData(data, col, order, isDefaultSort) {
    let sortedData = data.map((row, sIndex) => ({
        data: row.data[col],
        rowData: row.data,
        position: sIndex,
    }));
    if (col === 0) {
        if (!isDefaultSort) {
            sortedData.sort(protocolNameSort(order));
        }
    } else {
        sortedData.sort(defaultSort(order));
    }

    let tableData = [];

    for (let i = 0; i < sortedData.length; i++) {
        const row = sortedData[i];
        tableData.push(data[row.position]);
    }
    return tableData;
}
function sortData(data, col, order, isDefaultSort) {
    let sortedData = data.map((row, sIndex) => ({
        data: row.data[col],
        rowData: row.data,
        position: sIndex,
    }));
    if (col === 0) {
        if (!isDefaultSort) {
            sortedData.sort(statusSort(order));
        } else {
            sortedData.sort(defaultSort(order));
        }
    }
    if (col === 3) {
        if (!isDefaultSort) {
            sortedData.sort(jirastatus(order));
        } else {
             sortedData.sort(defaultSort(order));
        }
    }
    if (col === 4) {
        if (!isDefaultSort) {
            sortedData.sort(Assignee(order));
        } else {
             sortedData.sort(defaultSort(order));
        }
    }
    let tableData = [];
    for (let i = 0; i < sortedData.length; i++) {
        const row = sortedData[i];
        tableData.push(data[row.position]);
    }
    return tableData;
}
function sortGraphData(data,col,order){
    let sortedData = data.map((row, sIndex) => ({
        data: row.data[col],
        rowData: row.data,
        position: sIndex,
    }));
    if(col === 1 || col === 2){
     sortedData.sort(defaultSort(order));
    }
    let tableData = [];
    for (let i = 0; i < sortedData.length; i++) {
        const row = sortedData[i];
        tableData.push(data[row.position]);
    }
    return tableData;
}

function defaultSort(order) {
    return (a, b) => {
        if (a.data === null) {
            a.data = '';
        }
        if (b.data === null) {
            b.data = '';
        }
        return (
            (typeof a.data.localeCompare === 'function' ? a.data.localeCompare(b.data) : a.data - b.data) *
            (order === 'asc' ? 1 : -1)
        );
    };
}

function protocolNameSort(order) {
    return (a, b) => {
        let sort;
        if (order === "desc") {
            if ((a.data.pname) > (b.data.pname)) {
                sort = 1;
            } else {
                sort = -1;
            }
            return (
                sort
            );
        } else {
            if ((a.data.pname) < (b.data.pname)) {
                sort = 1;
            } else {
                sort = -1;
            }
            return (
                sort
            );
        }
    };
}
function statusSort(order) {
    return (a, b) => {
        let sort;
        if (order === "desc") {
            if ((a.data.resourceid) > (b.data.resourceid)) {
                sort = 1;
            } else {
                sort = -1;
            }
            return (
                sort
            );
        }
        else {
            if ((a.data.resourceid) < (b.data.resourceid)) {
                sort = 1;
            } else {
                sort = -1;
            }
            return (
                sort
            );
        }
    };
}

function symptomsInitSort(order) {

    return (a, b) => {
        return (
            (a.data.jirastatus - b.data.jirastatus) *
            (order === 'asc' ? -1 : 1)
        );
    };
}
function medAdherenceInitSort(order) {
    return (a, b) => {
        return (
            (a.adherence_percent.adherence_percent - b.adherence_percent.adherence_percent) *
            (order === 'asc' ? -1 : 1)
        );
    };
}

function lastAppUsedInitialSort(order) {
    return (a, b) => {
        return (
            (a.data - b).data *
            (order === 'asc' ? -1 : 1)
        );
    };
}
function Assignee(order) {
    return (a,b)=>{
        let sort;
        if(order==="desc"){
            if((a.data.jiraAssignee) > (b.data.jiraAssignee)){
                sort=1;
            } else{
                sort=-1;
            }
            return (
                sort
            );
        }
        else {
            if((a.data.jiraAssignee) < (b.data.jiraAssignee)){
                sort=1;
            } else{
                sort=-1;
            }
            return (
                sort
            );
        }
    };
}

function jirastatus(order) {
    return (a,b)=>{
        let sort;
        if(order==="desc"){
            if((a.data.jirastatus) > (b.data.jirastatus)){
                sort=1;
            } else{
                sort=-1;
            }
            return (
                sort
            );
        }
        else {
            if((a.data.jirastatus) < (b.data.jirastatus)){
                sort=1;
            } else{
                sort=-1;
            }
            return (
                sort
            );
        }
    };
}
exports.sortGraphData = sortGraphData;
exports.sortData = sortData;
exports.initialSort  = initialSort;
exports.symptomsInitialSort =symptomsInitialSort;
exports.adherenceInitialSort = adherenceInitialSort;
exports.lastAppUserInitialSort =lastAppUserInitialSort;


